'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventStatusSelect = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventStatusSelect = function EventStatusSelect(refs, applyConfig) {
    var optionConfig = refs.optionConfig;
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.ComboBox', _extends({
        cls: 'ns-combo',
        style: 'margin-bottom:' + _Style2.default.comboBottomMargin + 'px',
        width: _Style2.default.cmpWidth,
        labelWidth: _Style2.default.labelWidth,
        fieldLabel: i18n.event_status,
        labelSeparator: null,
        labelStyle: 'color:#333',
        queryMode: 'local',
        valueField: 'id',
        displayField: 'name',
        editable: false,
        value: optionConfig.getEventStatus('def').id,
        store: Ext.create('Ext.data.Store', {
            fields: ['id', 'name', 'index'],
            data: optionConfig.getEventStatusRecords()
        })
    }, applyConfig || {}));
};

exports.EventStatusSelect = EventStatusSelect;
exports.default = EventStatusSelect;
//# sourceMappingURL=EventStatus.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/EventStatus.js
 ** module id = 307
 ** module chunks = 0
 **/